import template from './kp-global-search.tpl.pug';

/**
 * @ngdoc controller
 * @name GlobalSearchComponentController
 * @module portaro.components.global-search
 */

class GlobalSearchComponentController {
    $element;
    form;
    _searchValue;

    /**
     * @param {jQuery} $element
     * @param {GlobalSearchService} globalSearchService
     */
    /*@ngInject*/
    constructor($element, globalSearchService) {
        this.$element = $element;
        globalSearchService.setSearchComponentController(this);
    }

    $postLink() {
        this.form = this.$element[0].querySelector('form');
    }

    $onChanges(changesObject) {
        if (changesObject.searchPhrase) {
            this.searchValue = changesObject.searchPhrase.currentValue;
        }
    }

    search() {
        if (this._searchValue) {
            this.form.submit();
        }
    }

    get searchValue() {
        return this._searchValue;
    }

    set searchValue(searchPhrase) {
        if (this.form) {
            this.form.querySelector('input[name="q"]').value = searchPhrase;
        }
        this._searchValue = searchPhrase;
    }
}


/**
 * @ngdoc component
 * @module portaro.components.global-search
 * @name kpGlobalSearch
 *
 * @param {string} formAction Action attribute inserted to form element
 * @param {string=} searchValue Search phrase
 *
 * @description
 * This non-visual component is for temporary use, until portaro is non-SPA.
 * It ensures global searching through classic submitted form, which can be triggered from everywhere in JS
 * through {@link service:globalSearchService service}
 */
export default class GlobalSearchComponent {
    static componentName = 'kpGlobalSearch';

    templateUrl = template;
    bindings = {
        formAction: '@',
        searchPhrase: '<?'
    };
    controller = GlobalSearchComponentController;
    controllerAs = 'gscc';
}